import {h, Component} from 'preact';
import Cookie from 'js-cookie';
import UPIModal from '@components/common/Modal';
import {GetSmsUpsLabel} from '@services/SmsService/query.graphql';
import {CallRepairsLink, PageContent} from '@containers/SmsPortal/components';
import Button from '@components/common/Button';
import Spinner from '@components/common/Spinner';
import {Query} from 'react-apollo/index';

export const ShippingLabelError = () => (
    <div className="my-4 p-3 md:p-4 leading-tight bg-near-white rounded">
        <p className="text-fail">We were unable to generate a shipping label for this repair request.</p>
        <p className="mt-2 text-sm">
            This is commonly caused when our shipping provider is unable to fully verify the ship from address which was
            provided.
        </p>
        <p className="mt-2 text-sm">
            <strong>Please contact our Equipment Service Team</strong> at <CallRepairsLink/> to resolve this issue and
            provide you with a valid shipping label to complete this return shipment.
        </p>
    </div>
);

const ShippingLabelPrompt = props =>
    <UPIModal onClose={props.onClose}
              id="promptShippingLabel"
              title={'Remove extra labels'}
              isOpen={props.isOpen}>
        <div className="flex flex-col items-center">
            <p className={`mt-2 max-w-lg leading-normal text-center`}>
                Please remove ALL previous labels & stickers when packaging equipment. Only the UPS
                Label provided should be visible.</p>
            <Button className="my-4"
                    onClick={() => {
                        props.onClose();
                        setTimeout( props.onPrint, 0 );
                    }}>
                Got it!
            </Button>
        </div>
    </UPIModal>;

const ShippingLabelImage = ( props ) =>
    <figure className={`md:max-w-xs ${props.className || ''}`}>
        <figureCaption>
            <Button secondary onClick={props.onPrint}>
                <span className="whitespace-no-wrap">Print Label</span>
            </Button>
        </figureCaption>
        {props.showLabel &&
        <img alt="UPS Label"
             className="mt-4 block w-48"
             src={`data:application/pdf;base64,${props.image}`}/>
        }
    </figure>;

export class ShippingLabel extends Component {

    state = {
        isPromptOpen: false
    };

    constructor( props ) {
        super( props );
        this.showPrompt = this.showPrompt.bind( this );
        this.closePrompt = this.closePrompt.bind( this );
    }

    requiresPrompt() {
        return Cookie.get( 'UpiPromptShippingLabels' ) == null;
    }

    showPrompt() {
        Cookie.set( 'UpiPromptShippingLabels', 1, {expires: 1} );
        this.setState( {isPromptOpen: true} );
    }

    closePrompt() {
        this.setState( {isPromptOpen: false} );
    }

    onPrintLabel = ( base64Image ) => () => this.context.actions.printShippingLabel( {base64Image} );

    render( props, state, context ) {
        let printLabel;
        if ( props.image ) {
            printLabel = this.onPrintLabel( props.image );
            return (
                <div className="inline-block">
                    <ShippingLabelPrompt
                        isOpen={this.state.isPromptOpen}
                        onClose={this.closePrompt}
                        onPrint={printLabel}
                    />
                    <ShippingLabelImage
                        onPrint={this.requiresPrompt() ? this.showPrompt : printLabel}
                        image={props.image}
                        showLabel={props.showLabel}
                        className={props.className}/>
                </div>
            );
        }

        return (
            <Query
                query={GetSmsUpsLabel}
                variables={{trackingNumber: props.trackingNumber}}>
                {( {loading, error, data} ) => {
                    if ( loading ) {
                        return <Spinner padding="0" message="Creating shipping label"/>
                    }
                    if ( error || !data.smsUpsLabel.image ) {
                        return <ShippingLabelError/>;
                    }

                    printLabel = this.onPrintLabel( data.smsUpsLabel.image );

                    return <div className="inline-block">
                        <ShippingLabelPrompt
                            isOpen={this.state.isPromptOpen}
                            onClose={this.closePrompt}
                            onPrint={printLabel}
                        />
                        <ShippingLabelImage
                            onPrint={this.requiresPrompt() ? this.showPrompt : printLabel}
                            image={data.smsUpsLabel.image}
                            showLabel={props.showLabel}
                            className={props.className}/>
                    </div>
                }}
            </Query>
        );
    }
}

